import { Navigate, useRoutes } from 'react-router-dom';

import { CONFIG } from 'src/config-global';

import { authRoutes } from './auth';
import { mainRoutes } from './main';
import { dashboardRoutes } from './dashboard';
import { reportRoutes } from './report';
import { xeroRoutes } from './xero';
import { compassRoutes } from './compass';

import { coaRoutes } from './coa';
import { errorRoutes } from './error';

import { managementRoutes } from './management';
import { pmsRoutes } from './pms';

// ----------------------------------------------------------------------

export function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to={CONFIG.auth.redirectPath} replace />,
    },

    // Auth
    ...authRoutes,

    // Dashboard
    ...dashboardRoutes,

    // Report
    ...reportRoutes,

    // Management
    ...managementRoutes,
    ...xeroRoutes,
    ...compassRoutes,

    ...coaRoutes,
    ...pmsRoutes,
    // Main
    ...mainRoutes,
    ...errorRoutes,
    // No match
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
